import { useContext } from 'react'
import { NotificationContext } from '../components/container'

export const useNotification = () => {
  const { pushNotification, deleteNotification } = useContext(
    NotificationContext
  )
  return { pushNotification, deleteNotification }
}
